export const ARCHIVE_TEAM_REQUEST = 'app/NestedTeamList/ARCHIVE_TEAM_REQUEST';
export const ARCHIVE_TEAM_SUCCESS = 'app/NestedTeamList/ARCHIVE_TEAM_SUCCESS';
export const ARCHIVE_TEAM_ERROR = 'app/NestedTeamList/ARCHIVE_TEAM_ERROR';

export const SEARCH_TEAMS_REQUEST = 'app/NestedTeamList/SEARCH_TEAMS_REQUEST';
export const SEARCH_TEAMS_SUCCESS = 'app/NestedTeamList/SEARCH_TEAMS_SUCCESS';
export const SEARCH_TEAMS_ERROR = 'app/NestedTeamList/SEARCH_TEAMS_ERROR';
